var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
var StyledFormLabel = styled(FormLabel)(function (_a) {
  var theme = _a.theme;
  return {
    '& .MuiFormLabel-asterisk': {
      color: theme.palette.error.main
    },
    color: theme.palette.text.primary,
    marginBottom: '0.3rem',
    fontWeight: 'bold'
  };
});
export var FieldLabel = function (props) {
  var required = props.required,
    label = props.label;
  return _jsx(StyledFormLabel, __assign({
    required: required
  }, {
    children: label
  }));
};